import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import enquire from 'enquire.js';
var breakpoints = {
  xs: '320px',
  sm: '544px',
  md: '767px',
  lg: '1024px',
  xl: '1272px'
};
var desktop = {
  min: _parsePxStringToInt(breakpoints.lg),
  max: null
};
var tablet = {
  max: _parsePxStringToInt('1023px'),
  min: _parsePxStringToInt('768px')
};
var mobile = {
  max: _parsePxStringToInt(breakpoints.md),
  min: null
};

var ViewportManager = /*#__PURE__*/function () {
  function ViewportManager(config) {
    _classCallCheck(this, ViewportManager);

    this.viewport = this._calculateInitialViewport();
    if (!global.callbacks) global.callbacks = {};
  }

  _createClass(ViewportManager, [{
    key: "register",
    value: function register(_ref) {
      var maxMobile = _ref.maxMobile,
          maxTablet = _ref.maxTablet,
          minDesktop = _ref.minDesktop;
      var self = this;
      var desktopQuery = "screen and (min-width:".concat(minDesktop, ")");
      var tabletQuery = "screen and (max-width:".concat(maxTablet, ")");
      var mobileQuery = "screen and (max-width:".concat(maxMobile, ")");
      if (this.registered) return; //If it goes from Tablet to Desktop

      enquire.register(desktopQuery, {
        match: function match() {
          self._changeViewport('desktop');
        }
      }); //If it goes from Desktop to Tablet

      enquire.register(tabletQuery, {
        match: function match() {
          self._changeViewport('tablet');
        }
      }); //If it goes from Tablet to Mobile

      enquire.register(mobileQuery, {
        match: function match() {
          self._changeViewport('mobile');
        },
        unmatch: function unmatch() {
          self._changeViewport('tablet');
        }
      });
      this.registered = true;
    }
  }, {
    key: "unregister",
    value: function unregister(_ref2) {
      var maxMobile = _ref2.maxMobile,
          maxTablet = _ref2.maxTablet,
          minDesktop = _ref2.minDesktop;
      var desktopQuery = "screen and (min-width:".concat(minDesktop, ")");
      var tabletQuery = "screen and (max-width:".concat(maxTablet, ")");
      var mobileQuery = "screen and (max-width:".concat(maxMobile, ")");
      if (!this.registered) return;
      enquire.unregister(desktopQuery);
      enquire.unregister(tabletQuery);
      enquire.unregister(mobileQuery);
    }
  }, {
    key: "subscribe",
    value: function subscribe(id, cb) {
      global.callbacks[id] = {
        callbackFn: cb
      };
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(id) {
      delete global.callbacks[id];
    }
  }, {
    key: "_calculateInitialViewport",
    value: function _calculateInitialViewport() {
      var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      var viewport;

      if ((desktop.min === null || desktop.min && width >= desktop.min) && (desktop.max === null || desktop.max && width <= desktop.max) && (desktop.min !== null || desktop.max !== null)) {
        viewport = 'desktop';
      } else if ((tablet.min === null || tablet.min && width >= tablet.min) && (tablet.max === null || tablet.max && width <= tablet.max) && (tablet.min !== null || tablet.max !== null)) {
        viewport = 'tablet';
      } else if ((mobile.min === null || mobile.min && width >= mobile.min) && (mobile.max === null || mobile.max && width <= mobile.max) && (mobile.min !== null || mobile.max !== null)) {
        viewport = 'mobile';
      }

      return viewport;
    }
  }, {
    key: "_changeViewport",
    value: function _changeViewport(currentViewport) {
      this.viewport = currentViewport;
      var callbackKeys = Object.keys(global.callbacks);

      if (callbackKeys.length > 0) {
        callbackKeys.forEach(function (key) {
          if (global.callbacks && global.callbacks[key] && global.callbacks[key].callbackFn) {
            global.callbacks[key].callbackFn(currentViewport);
          }
        });
      }
    }
  }]);

  return ViewportManager;
}();

export default new ViewportManager(); //Helpers

function _parsePxStringToInt(string) {
  if (typeof string == 'number') return string;
  if (!string.indexOf('px')) return parseInt(string);
  return parseInt(string.split('px')[0]);
}